export const SLIPPAGE_TOLERANCE_PERCENTAGE = 0.5;
export const HIGH_PRICE_IMPACT_THRESHOLD_PERCENTAGE = 10;
export const MAXIMUM_PRICE_IMPACT_THRESHOLD_PERCENTAGE = 20;
